import { TranslatePipe, TranslateService } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import { IrbSubscriptionDetailsType } from "../../../../apis/networkdashboard/graphql/graphql";
import { AliasEditorComponent } from "../../../../components/common/alias-editor/alias-editor.component";
import { TrafficLineChart } from "../../../../components/dashboard/traffic-line-chart/traffic-line-chart.component";
import {
  TrafficSubject,
  makeAllServicesOption,
  makeNamedOption,
} from "../../../../components/dashboard/traffic-line-chart/traffic-line-chart.helpers";
import { PortServicesPanel } from "../../../../components/subscription-detail/port-services-panel/port-services-panel";
import { ServiceId } from "../../../../components/subscription-detail/service-id/service-id";
import { SubscriptionDetailHeader } from "../../../../components/subscription-detail/subscription-detail-header/subscription-detail-header";
import { ThirdPartyServiceIdsRowContentComponent } from "../../../../components/subscription-detail/third-party-service-ids-row-content/third-party-service-ids-row-content";
import { ServiceSpeedPipe } from "../../../../helpers/service-speed-pipe/service-speed-pipe";
import { SubscriptionDatePipe } from "../../../../helpers/subscription-datepipe/subscription-datepipe";
import { PortShortcutMenu } from "../port-subscription/components/port-shortcut-menu/port-shortcut-menu";
import { SubscriptionViewBase } from "../subscription-view-base";

@Component({
  selector: "irb-subscription-view",
  templateUrl: "irb-subscription-view.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AliasEditorComponent,
    PortShortcutMenu,
    ServiceId,
    ServiceSpeedPipe,
    SubscriptionDatePipe,
    PortServicesPanel,
    SubscriptionDetailHeader,
    ThirdPartyServiceIdsRowContentComponent,
    TrafficLineChart,
    TranslatePipe,
  ],
})
export class IrbSubscriptionViewComponent extends SubscriptionViewBase<IrbSubscriptionDetailsType> {
  private translate = inject(TranslateService);
  protected readonly chartSubjects = computed<TrafficSubject[]>(() => [
    makeAllServicesOption(this.subscriptionId(), this.translate),
    ...(this.subscription().services ?? []).map(makeNamedOption),
  ]);

  protected domain = computed(() => this.subscription().domain);
  protected portSpeed = computed(() => this.subscription().portSpeed);
}
